<template>
  <div class="max-w-4xl mx-auto bg-white sm:shadow-md">
    <Picture
      v-if="imgSrc && !noImage"
      imgClass="w-full object-cover object-top"
      :src="imgSrc"
    />
    <div class="leading-relaxed">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Picture from "../components/Picture.vue";

export default {
name: "Page",
components: {
  Picture,
},
props: {
  imgSrc: {
    type: String,
    default: "img/treppe.jpg"
  },
  noImage: {
    type: Boolean,
    default: false
  }
}
};
</script>